import { ActionRow, FauxSelect, SettingsCard, Tag } from '../SettingsKit'

export default function AdminTab() {
    return (
        <>
            <div className="mb-4 rounded-md border border-arwen-100 bg-arwen-50/60 px-3 py-2 text-xs text-arwen-700">
                Everything in this tab is admin-only.
            </div>

            <SettingsCard title="Team">
                <ActionRow
                    label="Team assignment"
                    description="Assign this profile to a team."
                    action="Remove from team"
                    badges={<FauxSelect value="Acme — Social" />}
                />
            </SettingsCard>

            <SettingsCard title="Subscription & authorisation">
                <ActionRow
                    label="Profile subscription and authorisation"
                    description="Manage the subscription and validation state for this profile."
                    action="Open"
                />
            </SettingsCard>

            <SettingsCard title="Notifications">
                <ActionRow
                    label="Notification configuration"
                    description="Configure how and when notifications are sent for this profile."
                    action="Open"
                />
            </SettingsCard>

            <SettingsCard title="Meta ad-account visibility" badges={<Tag label="Meta only" />}>
                <ActionRow
                    label="Ad-account visibility"
                    description="Live diagnostic for the Meta ad accounts our token can see — use when ad-comment classification looks off."
                    action="Open"
                />
            </SettingsCard>

            <SettingsCard title="Danger zone">
                <ActionRow
                    label="Delete this profile"
                    description="Soft-deletes the profile. Takes 15–30 minutes to fully remove."
                    action="Delete profile"
                    danger
                />
            </SettingsCard>
        </>
    )
}
